import { DimensionAndWeightDisplay } from './DimensionDisplay';
import { P2GBox, P2GGrid, P2GText } from '@parcel2go/core-ui';
import { AppCard } from '~/components/card/app-card';
import { toDisplayCurrency } from '~/components/currency/toDisplayCurrency';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  totalValue?: number;
  totalWeight?: number;
  currencyCode?: string;
  children?: React.ReactNode;
  hideTotals?: boolean;
}

export const ContentSummaryTable: React.FC<props> = ({
  totalValue: total,
  currencyCode,
  totalWeight,
  children,
  hideTotals
}) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <AppCard>
      <AppCard>
        <P2GBox p={2}>{children}</P2GBox>
      </AppCard>
      {!hideTotals && (totalWeight > 0 || total > 0) && (
        <P2GBox p={2}>
          <P2GGrid container>
            {total > 0 && (
              <P2GGrid item xs={6}>
                <P2GText>
                  <Trans
                    t={t}
                    i18nKey="CONTENTS_TOTAL_VALUE"
                    values={{ value: toDisplayCurrency(currencyCode, total) }}
                    defaults="<strong>Shipment Value: {{value}}</strong>"
                  />
                </P2GText>
              </P2GGrid>
            )}
            {totalWeight > 0 && (
              <P2GGrid item xs={6}>
                <P2GText>
                  <Trans
                    t={t}
                    i18nKey="CONTENTS_TOTAL_WEIGHT"
                    components={{
                      dimensionComponent: <DimensionAndWeightDisplay dimensions={{ Weight: totalWeight }} />
                    }}
                    defaults="<strong>Shipment Weight:  <dimensionComponent /></strong>"
                  />
                </P2GText>
              </P2GGrid>
            )}
          </P2GGrid>
        </P2GBox>
      )}
    </AppCard>
  );
};
